function formatDate(dateStr?: string, showTime?: boolean) {
  if (!dateStr) return "";
  const d = new Date(dateStr);

  if (showTime) {
    const dateOptions: Intl.DateTimeFormatOptions = {
      month: "short",
      day: "numeric",
      year: "numeric",
    };
    const timeOptions: Intl.DateTimeFormatOptions = {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };

    const datePart = d.toLocaleDateString(undefined, dateOptions);
    const timePart = d.toLocaleTimeString(undefined, timeOptions);

    return `${datePart} ${timePart}`;
  }

  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

type DateBadgeProps = {
  date: string | undefined;
  showTime?: boolean;
};

export const DateBadge = ({ date, showTime }: DateBadgeProps) => {
  return <div className="flex items-center gap-2">{date ? formatDate(date, showTime) : "—"}</div>;
};
